import { PackageDeployerFormBaseDataProvider } from './PackageDeployerFormBaseDataProvider';

export class PackageDeployerFormGzDataProvider extends PackageDeployerFormBaseDataProvider {}
